import * as React from 'react'
import { UserVerificationForm } from './UserVerificationForm'
import { UserVerificationInfo } from './UserVerificationInfo'
import { UserVerificationResend } from './UserVerificationResend'

export const UserVerification = props => {
  const [tokenAlreadySent, setTokenAlreadySent] = React.useState(false)
  const [codePage, setCodePage] = React.useState(true)
  const [infoPage, setInfoPage] = React.useState(false)
  const [resendPage, setResendPage] = React.useState(false)

  const goToInfo = () => {
    setCodePage(false)
    setInfoPage(true)
  }

  const goToResend = () => {
    setInfoPage(false)
    setResendPage(true)
  }

  const goToVerification = () => {
    setResendPage(false)
    setInfoPage(false)
    setCodePage(true)
  }

  const {
    customGenerateTokenService,
    customValidateTokenService,
    tokenServicePayload,
    skipAutoTokenGeneration,
    onTokenAlreadyRequested,
    onValidationError,
    ...restProps
  } = props

  return (
    <div>
      {codePage && (
        <UserVerificationForm
          {...restProps}
          customGenerateTokenService={customGenerateTokenService}
          customValidateTokenService={customValidateTokenService}
          tokenServicePayload={tokenServicePayload}
          skipAutoTokenGeneration={skipAutoTokenGeneration}
          onTokenAlreadyRequested={onTokenAlreadyRequested}
          onValidationError={onValidationError}
          tokenAlreadySent={tokenAlreadySent}
          setTokenAlreadySent={setTokenAlreadySent}
          goToInfo={goToInfo}
        />
      )}
      {infoPage && (
        <UserVerificationInfo
          {...restProps}
          goToVerification={goToVerification}
          goToResend={goToResend}
        />
      )}
      {resendPage && (
        <UserVerificationResend
          {...restProps}
          customGenerateTokenService={customGenerateTokenService}
          tokenServicePayload={tokenServicePayload}
          onTokenAlreadyRequested={onTokenAlreadyRequested}
          setTokenAlreadySent={setTokenAlreadySent}
          goToVerification={goToVerification}
        />
      )}
    </div>
  )
}
